export const COLOR_PRIMARY = '#008489';
export const COLOR_PRIMARY_GRADIENT_VERTICAL = 'l(270) 0:#CBE6E7 1:#008489';
export const COLOR_LABEL = 'rgba(0,0,0,0.85)';
export const COLOR_BLUE_56AAAD = '#56aaad';
export const COLOR_LINE_CHART = '#979797';
export const COLOR_LIGHT_GREEN = '#b2dadc';
export const COLOR_BRIGHT_GREEN = '#08a17b';
export const COLOR_RANGE_BAR_LINE_WHITE = '#f0f0f0';
export const COLOR_RANGE_BAR_BACKGROUND_WHITE = '#ffffff';
export const COLOR_RANGE_BAR_PRIMARY = 'rgba(8, 161, 123, 0.09)';
export const COLOR_RANGE_BAR_BRIGHT_GREEN = 'rgba(0, 132, 137, 0.1)';
export const COLOR_FONT_BLACK = 'rgba(0, 0, 0, 0.85)';
export const SIZE_LABEL_FONT = 14;
export const SIZE_LABEL_HEIGHT = 22;
// SCALE = WIDTH_TIP / WIDTH_BAR_CHART
export const SCALE_BAR_TIP = 0.0037;
